
































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class CartHeader extends Vue {
  @Prop({ type: Boolean }) isEmpty?: boolean;
  @Prop({ type: Boolean }) hasSelection?: boolean;
  @Prop({ type: Array, default: [] }) selection!: string[];
  @Prop({ type: Boolean }) isOpen!: boolean;
  @Prop({ type: Number, default: 0 }) cartCount!: number;

  get icon() {
    return this.isOpen ? 'mdi-close' : 'mdi-chevron-up';
  }
}
